import React from 'react';
import { useLanguageValue } from '../../externals/language';
import LanguageSwitcher from '../application/LanguageSwitcher';
import ipcLogoSmall from '../../images/ipc_logo_small.png';

export const AppHeaderRightContainer = () => {
  const [{ currentLanguage }] = useLanguageValue();
  return (
    <div className="header-right-container">
      <LanguageSwitcher currentLanguage={currentLanguage} />
      <div className="vertical-divider" />
      <img
        className="logo"
        alt="IPC logo"
        src={ipcLogoSmall}
      />
    </div>
  );
};

export default AppHeaderRightContainer;
